<!-- direct image, so no processing through file service -->
@if (directImage() && src()) {
  <img [src]="src()" [attr.alt]="altText() !== '' ? altText : null" />
}


@else {
  <!-- image provided by file service -->
  @if (imagePayload(); as payload) {
    @switch (payload?.status) {
      @case (status.COMPLETED) {
        <ng-container [ngTemplateOutlet]="completed" [ngTemplateOutletContext]="{ src: payload?.src }" />
      }
      @case (status.PENDING) {
        <ng-container [ngTemplateOutlet]="pending" />
      }
      @case (status.ERROR) {
        <ng-container [ngTemplateOutlet]="error" />
      }
      @case (status.INVALID) {
        <ng-container [ngTemplateOutlet]="error" />
      }
    }

    <ng-template #completed let-src="src">
      @if (src; as imageSrc) {
        <img [src]="imageSrc" [attr.alt]="altText() !== '' ? altText : null" />
      }
    </ng-template>

    <ng-template #pending>
      <osp-spinner size="small"></osp-spinner>
    </ng-template>

    <ng-template #error>
      <img
        [ospTooltip]="'shared.attachment.fileNotFound' | translate"
        [src]="notFoundSvgIcon"
        [alt]="'shared.attachment.fileNotFound' | translate"
      />
    </ng-template>

  }
}
